import { helper } from '@ember/component/helper';

import { mapDataUrl } from 'rise-ui/utils/external-map.js';

export default helper(function linkToMapForItemHelper() {
  return mapDataUrl();
});
